<div [class]="questionContainerClasses()">
  @if(shouldShowQuestionTitle()) {
    <div class="question-title d-flex align-items-center gap-2">
      @if(shouldShowQuestionNumber()) {
        <span class="badge rounded-pill bg-primary border text-white fs-default">{{ questionNumber() }}</span>
      }
      @if(question().title !== null && question().title !== '') {
        <app-headline
          [type]="'h6'"
          [class]="'text-primary fw-bold'"
          [title]="question().title ?? ''"
        ></app-headline>
      }
      @if(shouldShowAffectedRuleIcon()) {
        <app-tooltip
          [tooltipTarget]="affectedRuleTooltipTarget()"
          [text]="affectedRuleTooltipText()"
          [type]="'Default'"
          [width]="'auto'"
          [height]="'auto'"
          [icon]="'rule'"
          [iconClass]="affectedRuleTooltipClass() + ' fs-5 p-1 text-orange'"
        ></app-tooltip>
      }
    </div>
  }

  @if(question().description !== null && question().description !== '') {
    <div class="question-description d-flex mt-2">
      <app-content
        [type]="'richtext'"
        [innerHTML]="question().description ?? ''"
      ></app-content>
    </div>
  }

  @if(attachmentsAvailable()) {
    <div class="d-flex justify-content-end align-items-center w-100">
      <app-tooltip
        [tooltipTarget]="'.preview-question-attachments-' + question().position"
        [text]="('FEEDBACKQUESTIONSHOWATTACHMENTTOOLTIP' | translate)"
        [type]="'Default'"
        [width]="'auto'"
        [height]="'auto'"
      >
        <app-form-button
          [cssClass]="'preview-question-attachments-' + question().position + ' e-btn e-flat fw-bold fs-small text-muted p-1'"
          [text]="'SHOWATTACHMENTS' | translate"
          [icon]="'attach_file'"
          [iconPosition]="'left'"
          [iconClass]="'fs-5'"
          [hideTextOnMobile]="false"
          (click)="documentsAttachmentsDialogVisible.set(true)"
        ></app-form-button>
      </app-tooltip>
    </div>
  }

  <div class="d-flex flex-column w-100 my-3">
    @switch (question().type) {
      @case (FeedbackQuestionType.SINGLE_SELECTION) {
        <app-feedback-form-element-single-selection
          [question]="question()"
          [formGroup]="formGroup()"
          [controlNamePrefix]="controlNamePrefix()"
          [disabled]="disabled()"
        ></app-feedback-form-element-single-selection>
      }
      @case (FeedbackQuestionType.MULTI_SELECTION) {
        <app-feedback-form-element-multi-selection
          [question]="question()"
          [formGroup]="formGroup()"
          [controlNamePrefix]="controlNamePrefix()"
          [disabled]="disabled()"
        ></app-feedback-form-element-multi-selection>
      }
      @case (FeedbackQuestionType.DROPDOWN) {
        <app-feedback-form-element-dropdown
          [question]="question()"
          [formGroup]="formGroup()"
          [controlNamePrefix]="controlNamePrefix()"
          [disabled]="disabled()"
        ></app-feedback-form-element-dropdown>
      }
      @case (FeedbackQuestionType.ORDERING) {
        <app-feedback-form-element-ordering
          [question]="question()"
          [formGroup]="formGroup()"
          [controlNamePrefix]="controlNamePrefix()"
          [disabled]="disabled()"
        ></app-feedback-form-element-ordering>
      }
      @case (FeedbackQuestionType.SLIDER) {
        <app-feedback-form-element-slider
          [question]="question()"
          [formGroup]="formGroup()"
          [controlNamePrefix]="controlNamePrefix()"
          [disabled]="disabled()"
        ></app-feedback-form-element-slider>
      }
      @case (FeedbackQuestionType.RATING) {
        <app-feedback-form-element-rating
          [question]="question()"
          [formGroup]="formGroup()"
          [controlNamePrefix]="controlNamePrefix()"
          [disabled]="disabled()"
        ></app-feedback-form-element-rating>
      }
      @case (FeedbackQuestionType.TEXT_INPUT) {
        <app-feedback-form-element-text-input
          [question]="question()"
          [formGroup]="formGroup()"
          [controlNamePrefix]="controlNamePrefix()"
          [disabled]="disabled()"
        ></app-feedback-form-element-text-input>
      }
      @case (FeedbackQuestionType.DATE_TIME) {
        <app-feedback-form-element-date-time
          [question]="question()"
          [formGroup]="formGroup()"
          [controlNamePrefix]="controlNamePrefix()"
          [disabled]="disabled()"
        ></app-feedback-form-element-date-time>
      }
      @case (FeedbackQuestionType.TIME) {
        <app-feedback-form-element-time
          [question]="question()"
          [formGroup]="formGroup()"
          [controlNamePrefix]="controlNamePrefix()"
          [disabled]="disabled()"
        ></app-feedback-form-element-time>
      }
      @case (FeedbackQuestionType.DATE) {
        <app-feedback-form-element-date
          [question]="question()"
          [formGroup]="formGroup()"
          [controlNamePrefix]="controlNamePrefix()"
          [disabled]="disabled()"
        ></app-feedback-form-element-date>
      }
      @case (FeedbackQuestionType.FILES) {
        <app-feedback-form-element-files
          [question]="question()"
          [formGroup]="formGroup()"
          [controlNamePrefix]="controlNamePrefix()"
          [disabled]="disabled()"
        ></app-feedback-form-element-files>
      }
    }
  </div>

  @if (shouldShowRequiredAnswerError()) {
    <div class="error-label mt-1 ps-md-3 w-100" role="alert">
      {{ 'SELECTIONREQUIRED' | translate }} 
    </div>
  }

  @for(commentField of commentFields(('FEEDBACKMANDATORYCOMMENTLABEL' | translate)); track commentField.controlName) {
    <div class="d-flex flex-column mt-2 ps-md-3 w-100">
      <app-form-label [label]="commentField.label"></app-form-label>
      <app-form-textarea
        [placeholder]="('FEEDBACKMANDATORYCOMMENTPLACEHOLDER' | translate)"
        [errorText]="('FEEDBACKMANDATORYCOMMENTREQUIRED' | translate)"
        [fCN]="commentField.controlName"
        [fG]="formGroup()"
        [disabled]="disabled()"
        [maxChars]="200"
        [rows]="4"
      ></app-form-textarea>
    </div>
  }
</div>

@if(documentsAttachmentsDialogVisible()) {
  <app-dialog-documents-attachments
    [visible]="documentsAttachmentsDialogVisible()"
    (visibleChange)="documentsAttachmentsDialogVisible.set($event)"
    [files]="questionAttachmentFiles()"
  ></app-dialog-documents-attachments>
}
